export const convertDaysToSeconds = (value: string):number => {
  return Number(value) * 86400;
};

export const convertSecondsToDays = (value: number):string => {
  return (value / 86400).toString();
};